<template>
  <div>
    <FiltroAnexos
      :value="showFiltro"
      @filtrar-anexos="(filtro) => filtrarAnexos(filtro)"
      @limpar-filtro="cleanFiltro()"
      @close="showFiltro = false"
    />

    <table-cadu
      :class="$vuetify.breakpoint.xs ? 'mandatos-mobile' : 'mandatos'"
      v-model="selected"
      custom
      :loading="isLoading"
      nameTab="anexos"
      :append-icon="'$vuetify.icons.chevron-down'"
      :showCheck="false"
      :rows="rows"
      :rowsHeader="rowsHeader"
      :items="['05', '10', '15', '20']"
      :elementsPerPageProp="elementsPerPage"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :texto="canEdit ? '+ adicionar anexo' : ''"
      :editar="canEdit"
      :ordemProp="ordem"
      :disabledButtons="disabledButtons"
      :showDownload="true"
      @change-element="(element) => changeSelect(element)"
      @change-page="(page) => changePage(page)"
      @ordena="(ordem) => ordernaTable(ordem)"
      @clickButton="(obj) => clickItem(obj)"
      @filtro-click="showFiltro = true"
      @download="downloadXls()"
    />

    <modal-anexo
      :value="showModalAnexo"
      @cancel="showModalAnexo = false"
      @reload-grid="success()"
      @create-another="createAnother()"
    />

    <SucessoModal
      :genericMessage="messageAnexo"
      :showSucess="showSucess"
      :sucessType="type"
      successName="Documento adicionado com sucesso!"
      @close="closeSuccess()"
    />

    <ErrorModal v-model="error" :errObj="errObj" />

    <ExcluirModal
      :text="'Tem certeza que deseja excluir esse anexo permanentemente?'"
      :showDelete="showDelete"
      @close="showDelete = false"
      @confirmDelete="apagarAnexo"
    />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import Anexo from '@/services/Anexos/Anexo'
import FiltroAnexos from './FiltroAnexos'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
export default {
  components: {
    FiltroAnexos,
    ErrorModal
  },
  data() {
    return {
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      role: '',

      // OBJETO
      anexos: {},
      showDelete: false,
      anexoId: 0,

      rowsHeader: [
        { text: 'Nome do Arquivo', icon: 'repeat' },
        { text: 'Aba Relacionada', icon: 'repeat' },
        { text: 'Data Upload', icon: 'repeat' },
        { text: 'Nome do usuário', icon: 'repeat' }
      ],
      rows: [],
      elementsPerPage: '10',
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 0,
      ordem: 'asc',
      campoOrdenado: '',
      isLoading: true,
      selected: [],
      disabledButtons: [false, false, false, true, false],

      // FILTRO
      showFiltro: false,
      abaRelacionada: '',
      dataFim: '',
      dataInicio: '',
      tipoDocumentoId: '',

      showModalAnexo: false,
      showSucess: true,
      createAnotherAnexo: false,
      type: '',
      messageAnexo: 'Documento anexado com sucesso!',

      error: false,
      errObj: {},
      loadingOverlay: false
    }
  },
  computed: {
    canEdit() {
      return (this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente') && !this.isLoading
    },
    args() {
      return `direcaoOrdenacao=${this.ordem}&ordenacao=${this.campoOrdenado}&pagina=${this.pagina}&tamanhoPagina=${this.elementsPerPage}&abaRelacionada=${this.abaRelacionada}&dataFim=${this.dataFim}&dataInicio=${this.dataInicio}&tipoDocumentoId=${this.tipoDocumentoId}`
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.versaoUnimed = localStorage.getItem('versaoUnimed')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    this.permissaoBotoes()
    await this.getData(
      `ordenacao=tipoDocumento.nome,anoDocumento&direcaoOrdenacao=asc&tamanhoPagina=${this.elementsPerPage}`
    )
  },
  methods: {
    async getData(args) {
      this.showSucess = false
      this.isLoading = true
      await this.getAllAnexo(args)
      this.isLoading = false
    },
    async getAllAnexo(args) {
      let anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseAnexo = await anexo.getAnexo(args)
        this.anexos = responseAnexo.data
        this.rows = this.anexos.conteudo
        this.pagina = this.anexos.pagina
        this.qtPaginas = this.anexos.qtPaginas
        this.qtResultados = this.anexos.qtResultados
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async downloadArquivo(index) {
      let image = `${this.$appConfig.config.API}/api/arquivos/${this.rows[index].arquivo.container}/${this.rows[index].arquivo.uuid}`

      let anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        this.loadingOverlay = true
        let response = await anexo.exportarAnexo(image)
        let content = response.headers['content-disposition']
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
        document.body.appendChild(link)
        link.click()
        this.loadingOverlay = false
      } catch (err) {
        console.error(err)
      }
    },
    success() {
      this.showModalAnexo = false
      this.showSucess = true
      this.createAnotherAnexo = false
    },
    createAnother() {
      this.showModalAnexo = false
      this.showSucess = true
      this.createAnotherAnexo = true
    },
    async closeSuccess() {
      await this.getData(this.args)
      this.showModalAnexo = this.createAnotherAnexo
    },
    async downloadXls() {
      let anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        this.loadingOverlay = true
        let response = await anexo.download(this.getArgsDownload())
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'anexos.xlsx')
        document.body.appendChild(link)
        link.click()
        this.loadingOverlay = false
      } catch (err) {
        console.error(err)
      }
    },
    async paginate() {
      this.isLoading = true
      await this.getAllAnexo(this.args)
      this.isLoading = false
    },
    changeSelect(element) {
      this.elementsPerPage = element
      this.pagina = 1
      this.paginate()
    },
    changePage(page) {
      this.pagina = page.currentPage
      this.paginate()
    },
    ordernaTable(ordem) {
      this.getCampoOrdenado(ordem.index)
      this.ordem = ordem.ordem
      this.paginate()
    },
    getCampoOrdenado(index) {
      switch (index) {
        case 0:
          this.campoOrdenado = 'tipoDocumento.nome,anoDocumento'
          break
        case 1:
          this.campoOrdenado = 'abaRelacionada'
          break
        case 2:
          this.campoOrdenado = 'dataUpload'
          break
        case 3:
          this.campoOrdenado = 'usuarioUpload.nome'
          break
        default:
          this.campoOrdenado = ''
          break
      }
    },
    cleanFiltro() {
      this.getData('')
    },
    filtrarAnexos(filtro) {
      this.abaRelacionada = filtro.abaRelacionada.codigo
      this.tipoDocumentoId = filtro.tipoDocumento !== '' ? filtro.tipoDocumento.id : ''
      this.dataInicio = filtro.dataInicial
      this.dataFim = filtro.dataFinal
      this.pagina = 1
      this.getData(this.args)
    },
    clickItem(obj) {
      switch (obj.type) {
        case 'add':
          this.showModalAnexo = true
          break
        case 'recibo':
          this.downloadArquivo(obj.index)
          break
        case 'delete':
          this.anexoId = obj.selected[0]
          this.showDelete = true
          break
      }
    },

    async apagarAnexo() {
      this.loadingOverlay = true
      this.showDelete = false

      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.anexoId)

      await anexo
        .deleteAnexoVersaoTemp(this.$idUnimed)
        .then(() => {
          this.messageSuccess = 'Anexo apagado com sucesso!'
          this.showSuccess = true
          this.paginate()
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.loadingOverlay = false))
    },

    getArgsDownload() {
      let args = this.geradorParams(
        // ORDENAÇÃO
        {
          name: 'ordenacao',
          value: this.campoOrdenado
        },
        {
          name: 'direcaoOrdenacao',
          value: this.ordem
        }
      )
      return args
    },

    permissaoBotoes() {
      if (this.verifyPermission() && this.opcaoEditar) {
        this.disabledButtons = [false, false, true, true, false]
      } else {
        this.disabledButtons = [false, false, false, true, false]
      }
    },
    verifyPermission() {
      if (this.role === 'admin_brasil' || this.role === 'dirigente') {
        return true
      } else {
        return false
      }
    },

    geradorParams(...params) {
      let str = ''
      for (let p of params) {
        if (p.value) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    }
  },
  watch: {
    anexos() {
      this.rows = this.anexos.conteudo
      this.pagina = this.anexos.pagina
      this.qtPaginas = this.anexos.qtPaginas
      this.qtResultados = this.anexos.qtResultados
    }
  }
}
</script>

<style lang="sass" scoped>
.mandatos-mobile > .table-cadu
    padding: 20px 10px !important
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu > .table > table
    width: 100% !important

.mandatos-mobile > .table-cadu > .table > table
    width: 100% !important

.mandatos > .table-cadu > .table
  tbody
        tr
            td
                &:last-child
                    width: 360px
</style>
